import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as BoardStateActions from './board-state.actions';
import { BoardStateService } from './board-state-services/board-state.service';
import { DatasetService } from 'src/app/services/dataset.service';


@Injectable()
export class BoardStateEffects {
  constructor(
    private actions$: Actions,
    private boardStateService: BoardStateService,
    private datasetService: DatasetService
    ) {}

  loadBoardColors$ = createEffect(() => {
    return this.actions$.pipe(

      ofType(BoardStateActions.loadBoardColors),
      concatMap(() =>
        this.boardStateService.getBoardColors().pipe(
          map(colors => BoardStateActions.loadBoardColorsSuccess({ colors: colors })),
          catchError(error => of(BoardStateActions.loadBoardColorsFailure({ error }))))
      )
    );
  });

}
